import { useEffect, useState } from 'react';

interface BootLoaderProps {
  onTimeout?: () => void;
  timeout?: number;
}

/**
 * Boot Loader Component
 * Shows a loading screen during app initialization
 * Displays "Refreshing app data..." message if boot takes >3s
 */
export function BootLoader({ onTimeout, timeout = 3000 }: BootLoaderProps) {
  const [showRefreshing, setShowRefreshing] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowRefreshing(true);
      if (onTimeout) {
        onTimeout();
      }
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout, onTimeout]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="text-center">
        <div className="mb-4">
          <div className="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-[#007c86]"></div>
        </div>
        <p className="text-sm text-gray-500">
          {showRefreshing ? 'Refreshing app data...' : 'Loading...'}
        </p>
        {showRefreshing && (
          <p className="mt-2 text-xs text-gray-400">
            This may take a moment if you have cached data
          </p>
        )}
      </div>
    </div>
  );
}

